<script setup>
import {computed, ref} from "vue";
import { trans } from 'laravel-vue-i18n';
import EmailTemplateCreator from "./EmailTemplateCreator.vue";
import {useConfirm} from "primevue/useconfirm";
import ConfirmDialog from "primevue/confirmdialog";
import {router, usePage} from "@inertiajs/vue3";
const model = defineModel();
const rootEmailStyles = (template) => {
    return {
        fontFamily: template?.font,
        backgroundColor: '#' + template?.background_color,
        color: '#' + template?.text_color
    }
}
const props = defineProps({
    text:String,
    templates: Array
})
const templateCreator = ref(false);
const currentTemplate = ref(null);
const showActions = ref()
const confirm = useConfirm();

const confirmDelete = (event, id) => {
    confirm.require({
        target: event.currentTarget,
        message: trans('forms.confirm_delete_template'),
        icon: 'pi pi-exclamation-triangle',
        header: trans('common.are_you_sure'),
        rejectProps: {
            label: trans('common.cancel'),
            severity: 'secondary',
            outlined: true
        },
        acceptProps: {
            label: trans('common.yes_delete'),
            severity: 'danger'
        },
        accept: () => {
            router.visit('/app/email-themes/' + id, {
                method: 'DELETE'
            });
            currentTemplate.value = props?.templates[0];
        },
        reject: () => {
        }
    });
}
</script>

<template>
<div class="max-2xl:flex max-2xl:flex-wrap 2xl:grid grid-cols-3 gap-4">

    <div class="text-center cursor-pointer " @click="() => {
        templateCreator = true;
        currentTemplate = null
    }">
        <div class="border template mb-1 rounded-lg flex items-center justify-center bg-neutral-100 dark:bg-neutral-900 dark:border-neutral-700">
            <i class="pi pi-plus opacity-50" style="font-size: 1.5rem"></i>
        </div>
        <small>{{ $t('forms.template_add') }}</small>
    </div>
    <div v-for="template in templates" class="text-center cursor-pointer" @click.prevent="model = template">
        <div :style="rootEmailStyles(template)" class="border rounded-lg relative mb-1 transition-all rounded-b-0 flex hover:shadow flex-col justify-center items-center template" :class="{
            'border-t-blue-500 border-t-4': template === model
        }" @mouseenter="showActions = template.id" @mouseleave="showActions = null">
            <div id="logo-section" class="py-3 flex justify-center">
                <img :src="template.logo_image" style="width: 50px; height: 10px"/>
            </div>
            <div id="body-section" class="p-4 bg-white rounded-t-lg border border-b-0  mx-3" style="">

            </div>
            <div v-show="(showActions === template.id) && template.id_users" class="transition-all shadow absolute -top-4 -right-4 overflow-hidden rounded flex">
                <div class="p-2 border-l border-neutral-200 hover:bg-neutral-200 bg-neutral-100" @click.prevent="confirmDelete($event, template.id)">
                    <i class="pi pi-trash text-red-500" style="font-size: .75rem"></i>
                </div>

                <div class="p-2 bg-neutral-100 hover:bg-neutral-200" @click.prevent="() => {
                    templateCreator = true;
                    currentTemplate = template
                }">
                    <i class="pi pi-pencil" style="font-size: .75rem"></i>
                </div>

            </div>
        </div>

        <small>
            <i v-if="template.id_users" class="pi pi-sparkles text-yellow-600 -ml-2"></i>
            {{template.name}}
        </small>
    </div>
    <ConfirmDialog></ConfirmDialog>
    <email-template-creator v-model="templateCreator" :template="currentTemplate" :text="text"></email-template-creator>
</div>
</template>

<style scoped lang="scss">
.template {
    width: 70px;
    height: 70px;
}
</style>
